import { TextField, Container, Button, Typography, Paper, Box, CircularProgress, IconButton, InputAdornment } from '@mui/material';
import { Lock, Visibility, VisibilityOff } from '@mui/icons-material';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

const ChangePassword = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(true);
    const [showConfirmPassword, setShowConfirmPassword] = useState(true);

    const handleValidEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            api.post('/users/restet-password', { id, password });
        } catch (err) {
            setError('Falha ao redefinir senha!');
        } finally {
            setLoading(false);
        }
    }

    const passwordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const passwordVisibilityConfirm = () => {
        setShowConfirmPassword(!confirmPassword);
    };

    const passwordValid = () => {
        if (password.length == 0 || confirmPassword.length == 0) {
            return false;
        }
        if (password.length < 8 || confirmPassword.length < 8) {
            return false;
        }
        return password === confirmPassword;
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
            }}
        >
            <Container component="main" maxWidth="sm">
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'start',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid rgba(200, 208, 218, 0.25)',
                        width: '100%',
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{ mb: 2, color: '#000000', fontWeight: 'bold' }}
                    >
                        Mudar Senha
                    </Typography>
                    <Typography
                        component="p"
                        variant="body1"
                        sx={{ mb: 1, color: '#000000' }}
                    >
                        Informe a nova senha
                    </Typography>

                    <Box component="form" onSubmit={handleValidEmail} sx={{ width: '100%' }}>
                        <TextField
                            fullWidth
                            margin="normal"
                            id="password"
                            label="Senha"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                startAdornment: <Lock sx={{ color: '#10641c', mr: 1 }} />,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={passwordVisibility} edge="end" sx={{ color: '#10641c' }}>
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                sx: {
                                    backgroundColor: '#FFFFFF',
                                    color: '#000000',
                                    border: '1px solid rgba(200, 208, 218, 0.25)',
                                },
                            }}
                            InputLabelProps={{ sx: { color: '#10641c' } }}
                        />

                        <TextField
                            fullWidth
                            margin="normal"
                            id="password"
                            label="Confirmar Senha"
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            InputProps={{
                                startAdornment: <Lock sx={{ color: '#10641c', mr: 1 }} />,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={passwordVisibilityConfirm} edge="end" sx={{ color: '#10641c' }}>
                                            {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                sx: {
                                    backgroundColor: '#FFFFFF',
                                    color: '#000000',
                                    border: '1px solid rgba(200, 208, 218, 0.25)',
                                },
                            }}
                            InputLabelProps={{ sx: { color: '#10641c' } }}
                        />

                        {/* Exibição de Erro */}
                        {error && (
                            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                                {error}
                            </Typography>
                        )}

                        {/* Botão de Cadastro */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading || !passwordValid()}
                            sx={{
                                mt: 3,
                                mb: 2,
                                backgroundColor: '#10641c',
                                '&:hover': { bgcolor: '#094011' },
                                '&.Mui-disabled': {
                                    backgroundColor: '#82D48D',
                                    color: '#ACFAB8',
                                },
                            }}
                        >
                            {loading ? <CircularProgress size={24} /> : 'Redefinir Senha'}
                        </Button>

                        {/* Redirecionamento para Login */}
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant="body1" sx={{ color: '#000000' }}>Voltar par ao login?</Typography>
                            <Button
                                type="button"
                                variant="text"
                                onClick={() => navigate('/login')}
                                sx={{ color: '#10641c', '&:hover': { color: '#094011' } }}
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}


export default ChangePassword;